/* bf-product.js — BF mobile redesign (2026-09). Stream file; gate every behaviour on BF.isMobile(). Loaded deferred after bf-core.js. */
/* B1 owns: the mobile gallery dots, the tee size pills, and the Add-to-Cart intercept.
   ATC timeline (PROTOTYPE-MAP §3 / D4 §6.11): "Added ✓" at once → +140 ms mutate → +320 ms the bag drawer opens.
   Desktop is untouched — the legacy form keeps its native POST and .bf-buy is display:none at ≥ 750 px. */
(function () {
  "use strict";
  if (!window.BF) return;
  var BF = window.BF;

  /* Dawn interop (CONTRACTS §5): bare globals from pubsub.js / constants.js. */
  function dawnPublish(detail) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bf', cartData: detail && detail.cart });
      }
    } catch (e) { /* noop */ }
  }

  /* ---------------------------------------------------------------- gallery dots (rAF-throttled scroll) */
  function initGallery() {
    var track = document.querySelector('[data-bf-gallery]');
    var dotWrap = document.querySelector('[data-bf-dots]');
    if (!track || !dotWrap) return;
    var dots = BF.qsa('.bf-gallery__dot', dotWrap);
    if (dots.length < 2) return;
    var cur = 0, pending = false;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i < 0) i = 0;
        if (i > dots.length - 1) i = dots.length - 1;
        if (i === cur) return;
        dots[cur].classList.remove('is-active');
        cur = i;
        dots[cur].classList.add('is-active');
      });
    }, { passive: true });
  }

  /* ---------------------------------------------------------------- tee size pills */
  /* [data-bf-price] and [data-bf-size-label] exist twice on a sized product since B2 (buy block + sticky dock),
     so every copy is updated. The money string always comes from the pill's Liquid-rendered data-variant-money. */
  function initSizes() {
    var wrap = document.querySelector('[data-bf-sizes]');
    if (!wrap) return;
    var input = document.querySelector('[data-bf-variant-input]');
    var priceEls = BF.qsa('[data-bf-price]');
    var labelEls = BF.qsa('[data-bf-size-label]');
    wrap.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var pill = t.closest('.bf-buy__size');
      if (!pill || pill.disabled) return;
      BF.qsa('.bf-buy__size', wrap).forEach(function (p) {
        p.classList.remove('is-selected');
        p.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-selected');
      pill.setAttribute('aria-pressed', 'true');
      if (input) input.value = pill.getAttribute('data-variant-id') || input.value;
      /* the money string is rendered by Liquid per variant — never hand-rolled here */
      var money = pill.getAttribute('data-variant-money');
      var label = pill.getAttribute('data-variant-label') || pill.textContent.trim();
      if (money) priceEls.forEach(function (el) { el.textContent = money; });
      labelEls.forEach(function (el) { el.textContent = label; });
    });
  }

  /* ---------------------------------------------------------------- Add to Cart intercept (mobile only) */
  function initATC() {
    var form = document.querySelector('.bf-buy__form');
    if (!form) return;
    var btn = form.querySelector('[data-bf-atc]');
    if (!btn) return;
    var errEl = form.querySelector('[data-bf-atc-error]');
    var idle = btn.getAttribute('data-bf-label') || 'Add to Cart';
    var busy = false;
    /* B2: the sticky dock's button mirrors this one — same label, same .is-added (D4 §6.10 "same addLabel") */
    var btns = [btn];
    var dockBtn = document.querySelector('[data-bf-dock-atc]');
    if (dockBtn) btns.push(dockBtn);

    function setAdded() {
      btns.forEach(function (b) {
        b.classList.add('is-added');
        b.textContent = 'Added ✓';
      });
    }

    function restore() {
      btns.forEach(function (b) {
        b.classList.remove('is-added');
        b.textContent = b.getAttribute('data-bf-label') || idle;
      });
    }

    function fail(err) {
      restore();
      if (errEl) {
        errEl.textContent = (err && ((err.body && err.body.description) || err.message)) || 'Sorry, this item could not be added to your bag.';
        errEl.hidden = false;
      }
      busy = false;
    }

    form.addEventListener('submit', function (e) {
      if (!BF.isMobile()) return;               /* desktop keeps the native form POST */
      e.preventDefault();
      if (busy) return;
      busy = true;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

      var idInput = form.querySelector('input[name="id"]');
      var id = idInput && idInput.value;
      if (!id) { busy = false; return; }

      setAdded();

      BF.delay(140)
        .then(function () {
          return BF.cart.add({ id: id, quantity: 1 }, ['cart-icon-bubble', 'bf-cart-drawer'], 'atc');
        })
        .then(function (detail) {
          dawnPublish(detail);
          return BF.delay(180);                 /* 320 ms total from the tap */
        })
        .then(function () {
          BF.openSheet('bag');
          busy = false;
        })
        .catch(fail);
    });

    /* the label stays "Added ✓" behind the open drawer and resets only when it closes (D4 §6.11) */
    BF.on('bf:drawer:close', restore);

    /* B2: the dock button is outside the form, so it re-submits the same form and takes the same code path */
    if (dockBtn) {
      dockBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!BF.isMobile()) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* ---------------------------------------------------------------- sticky purchase dock (D4 §6.10) */
  /* Trigger, verbatim from the prototype: sticky = buyBlock.getBoundingClientRect().bottom < 60.
     rAF-throttled; mobile only (on desktop .bf-buy is display:none, so its rect would read 0 and always match). */
  function initDock() {
    var dock = document.querySelector('[data-bf-dock]');
    var buy = document.querySelector('.bf-buy');
    if (!dock || !buy) return;
    var visible = null, pending = false;

    function apply() {
      var next = BF.isMobile() && buy.getBoundingClientRect().bottom < 60;
      if (next === visible) return;
      visible = next;
      dock.classList.toggle('is-visible', next);
      dock.setAttribute('aria-hidden', next ? 'false' : 'true');
      if (next) dock.removeAttribute('inert');
      else dock.setAttribute('inert', '');
    }

    function onScroll() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; apply(); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (BF.onMobileChange) BF.onMobileChange(onScroll);
    apply();
  }

  /* ---------------------------------------------------------------- B3: "You May Like" (D4 §6.9) */
  /* Section Rendering (CONTRACTS §7): /recommendations/products?section_id=bf-recommendations&product_id=…&limit=4.
     The path is relative to the current origin, so the theme-preview cookie applies. The subline and the
     "View More" href belong to the PDP template's settings, which a separately rendered section cannot read,
     so they travel on the container's data attributes and are written onto the fetched block. */
  function initRecs() {
    var host = document.querySelector('[data-bf-recs]');
    if (!host || !BF.isMobile()) return;
    var pid = host.getAttribute('data-product-id');
    var base = host.getAttribute('data-url') || '/recommendations/products';
    if (!pid) return;
    var url = base + (base.indexOf('?') > -1 ? '&' : '?') +
      'section_id=bf-recommendations&product_id=' + encodeURIComponent(pid) + '&limit=4';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('recommendations ' + r.status)); })
      .then(function (html) {
        var inner = BF.parseHTML(html).querySelector('.bf-recs__inner');
        if (!inner || !inner.querySelector('.bf-card')) return;
        var sub = host.getAttribute('data-bf-subline');
        var subEl = inner.querySelector('[data-bf-recs-sub]');
        if (sub && subEl) subEl.textContent = sub;
        var more = host.getAttribute('data-bf-more');
        var moreEl = inner.querySelector('[data-bf-recs-more]');
        if (more && moreEl) moreEl.setAttribute('href', more);
        host.appendChild(inner);
      })
      .catch(function () { /* the container simply stays empty */ });
  }

  /* ---------------------------------------------------------------- B3: reveal the Okendo block from the mobile line */
  /* The mobile zero-state row replaces the legacy #reviews block at ≤ 749 px; "Write a Review" is the only way
     back to Okendo's own form, so the tap un-hides it (the href="#reviews" jump does the scrolling, and the
     `#reviews:target` CSS rule covers the no-JS path). */
  function initReviewLink() {
    var link = document.querySelector('[data-bf-write-review]');
    var pdp = document.querySelector('.bf-pdp');
    if (!link || !pdp) return;
    link.addEventListener('click', function () { pdp.classList.add('is-reviews-open'); });
  }

  BF.ready(function () {
    initGallery();
    initSizes();
    initATC();
    initDock();
    initRecs();
    initReviewLink();
  });
})();
